import { computed } from '@vue/composition-api';
import { LOCAL_STORAGE_KEY, useLocalStorage } from './use-local-storage';
const emptyEntry = {
    answers: [],
    files: [],
    comments: [],
    fileNameMappings: {},
};
export const useSurveyDataCache = (surveyId) => {
    const { setStoredValue, storedValue } = useLocalStorage(LOCAL_STORAGE_KEY.SURVEYS_DATA);
    if (!storedValue.value) {
        setStoredValue('{}');
    }
    const setRecord = (entry) => {
        setStoredValue(JSON.stringify({ ...storedValue.value, [surveyId]: entry }));
    };
    if (!storedValue.value[surveyId]) {
        setRecord({ ...emptyEntry });
    }
    const surveyCache = computed(() => storedValue.value?.[surveyId] || { ...emptyEntry });
    const deleteRecord = () => {
        const newCache = { ...storedValue.value };
        delete newCache[surveyId];
        setStoredValue(JSON.stringify(newCache));
    };
    //remove..
    return { surveyCache, setRecord, deleteRecord };
};
